import React from 'react'
import styled from 'styled-components'
import * as constants from '../../../../static/constants'
import Typography from 'components/atoms/_layouts/Typography'
import { Swiper, SwiperSlide } from 'swiper/react'
import { IIncludedItem } from 'static/interfaces'
import { TextWrapAlt } from 'components/atoms/TextWrapAlt'
import I18n from 'core/i18n'
import SVGIcon from 'components/atoms/SvgIcon'

interface IPostIncludedProps {
  includedItems: IIncludedItem[]
  showMoreHandler: () => void
}

interface IPostIncludedCardProps extends IIncludedItem {
  showMoreHandler: () => void
}

const PostIncludedCard = ({ type, description, showMoreHandler }: IPostIncludedCardProps) => (
  <PostIncludedCardWrapper>
    <div>
      <SVGIcon name={type} className="icon" ariaHidden={true} role="presentation" />
    </div>
    <Typography type="headline" size="sm" color="primary">
      {I18n.t(`post.included_category_${type}`)}
    </Typography>
    <TextWrapAlt text={description} showMoreHandler={showMoreHandler} />
  </PostIncludedCardWrapper>
)

export const PostIncluded: React.FC<IPostIncludedProps> = ({ includedItems, showMoreHandler }) => {
  if (!includedItems || includedItems.length === 0) {
    return null
  }

  return (
    <Swiper
      slidesPerView={1.6}
      spaceBetween={24}
      slidesOffsetBefore={16}
      slidesOffsetAfter={16}
      breakpoints={{
        480: {
          slidesPerView: 2,
          slidesOffsetBefore: 16,
          slidesOffsetAfter: 16,
        },
        720: {
          slidesPerView: 2.5,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0,
        },
        1200: {
          slidesPerView: 3,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0,
        },
      }}
    >
      {includedItems.map((item, index) => (
        <SwiperSlide key={index}>
          <PostIncludedCard
            type={item.type}
            description={item.description}
            showMoreHandler={showMoreHandler}
          />
        </SwiperSlide>
      ))}
    </Swiper>
  )
}

const PostIncludedCardWrapper = styled.div`
  display: flex;
  flex-shrink: 0;
  flex-direction: column;
  gap: 8px;
  min-width: 204px;
  height: 216px;
  border: 1px solid ${constants.COLORS.divider};
  border-radius: 16px;
  padding: 20px;
  user-select: none;

  .icon {
    width: 48px;
    height: 48px;
  }

  @media (max-width: ${constants.BREAKPOINT_TABLET_SMALL}) {
    width: auto;
  }
`
